export default __webpack_public_path__ + "static/ErinMaw-b38ab5dd17b3e4973f804c882e0b9486.png";